import { Tooltip } from "@/components/Common/Tooltip";
import { formatHours } from "@/lib/formatHours";
import { JobState } from "@/lib/jobState";
import { JOB_STATE_TOOLTIPS } from "./columnTooltips";

const STATE_ORDER: JobState[] = [
  "pending",
  "approved",
  "completed",
  "declined",
];

const STATE_LABELS: Record<JobState, string> = {
  pending: "Pending",
  approved: "Approved",
  completed: "Completed",
  declined: "Declined",
};

type JobStateSummaryProps = {
  hours: Record<JobState, number>;
};

export function JobStateSummary({ hours }: JobStateSummaryProps) {
  const stats = STATE_ORDER.map((state) => ({
    state,
    label: STATE_LABELS[state],
    value: formatHours(hours[state]),
  }));

  return (
    <div
      data-testid="job-state-summary"
      className="flex rounded-[10px] border border-slate-200 bg-white shadow-[0_1px_2px_#0000000A]"
    >
      {stats.map((stat, index) => (
        <Tooltip key={stat.state} message={JOB_STATE_TOOLTIPS[stat.state]}>
          {/* min-w-0 lets the flex-1 column shrink below its content's
              natural width so truncate can engage — a flex item's default
              min-width is auto (its content size), which would otherwise
              force the row wider than the 4-tile panel instead of clipping
              a long value like "137.25h". */}
          <div
            className={`flex min-w-0 flex-1 flex-col p-3 ${
              index > 0 ? "border-l border-slate-200" : ""
            }`}
          >
            <span className="truncate text-2xl font-semibold tabular-nums tracking-[-0.02em] text-slate-800">
              {stat.value}
            </span>
            <span className="mt-1 truncate text-xs font-medium text-slate-500">
              {stat.label}
            </span>
          </div>
        </Tooltip>
      ))}
    </div>
  );
}
